import { render } from "./Eredmeny.vue?vue&type=template&id=58c7fbca&scoped=true"
import script from "./Eredmeny.vue?vue&type=script&lang=js"
export * from "./Eredmeny.vue?vue&type=script&lang=js"

import "./Eredmeny.vue?vue&type=style&index=0&id=58c7fbca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c7fbca"]])

export default __exports__